<template>
  <div>
    <!-- search -->
    <search @getOperateLogDepartHistogram="getOperateLogDepartHistogram" :system-list="systemList"></search>
    <!-- chart view -->
    <el-row class="chart-box">
      <el-col :span="16" style="height: 70vh;">
        <!-- <bar-chart style="width: 100%;height: 70vh;"
                   :isClickAble="true" id="chart2"
                   :barxAxisData="barxAxisData"
                   :barSeriesData="barSeriesData"
                   @getOperateLogDepartPie="getOperateLogDepartPie"></bar-chart> -->
        <div class="ui-fullBox">
          <smart-chart id="logBarContainer" :echart-option="chartData.bar" :resizeable="true" :pixel-click="true" @echartpixelclick="getOperateLogDepartPie" />
        </div>
      </el-col>
      <el-col :span="8" v-show="isClick" style="height: 70vh;">
        <div class="ui-fullBox">
          <smart-chart id="logPieContainer" :echart-option="chartData.pie" :resizeable="true"/>
        </div>
        <!-- <pie-chart style="width: 100%;height: 70vh;" id="chart1" :pieLegendData="pieLegendData" :pieSeriesData="pieSeriesData"></pie-chart> -->
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import SmartChart from '@/components/smartChart';
import BarOption from '@/components/smartChart/options/bar';
import PieOption from '@/components/smartChart/options/singelPie';
import Search from './search';

export default {
  name: 'logStatistics',
  components: {
    Search,
    // pieChart,
    // barChart,
    SmartChart
  },
  data() {
    return {
      chartData: {
        bar: {
          loading: false,
          ...BarOption
        },
        pie: {
          loading: false,
          ...PieOption
        }
      },
      queryParams: {},
      systemList: [],
      isClick: false // 是否點擊
    };
  },
  computed: {
    ...mapGetters({
      userInfor: 'user/userInfor'
    })
  },
  methods: {
    async getOperationAelectALL() {
      // 获取操作系统
      const res = await this.$services.post({
        type: 'LOGSTATISTICS',
        url: 'getOperationAelectALL'
      });
      this.systemList = res.bean;
    },
    setOption(option, data) {
      option.legend.data = data.len;
      option.xAxis[0].data = data.x;
      option.series = data.series;
      option.loading = true;
    },
    async getOperateLogDepartHistogram(params) {
      this.isClick = false;
      this.chartData.bar.loading = false;
      if (params) {
        Object.assign(this.queryParams, this.queryParams, params);
      }
      const { bean } = await this.$services.post({
        type: 'LOGSTATISTICS',
        url: 'getOperateLogDepartHistogram',
        params: this.queryParams
      });

      let barxAxisData = [];
      let barSeriesData = [];
      const key = this.queryParams.depCode ? this.queryParams.depCode : this.userInfor.depCode;
      bean[key].forEach(item => {
        barxAxisData.push(item.dateStr);
        barSeriesData.push(item.operateTimes);
      });

      let option = this.chartData.bar;
      option.dataZoom = [
        {
          show: true,
          startValue: barxAxisData.length > 14 ? barxAxisData.length - 14 : 0,
          endValue: barxAxisData.length - 1
        }
      ];

      option.xAxis[0].data = barxAxisData;
      option.series = [
        {
          name: '操作次数',
          type: 'bar',
          barWidth: '60%',
          data: barSeriesData
        }
      ];
      option.loading = true;

    },
    async getOperateLogDepartPie(xIndex) {
      const date = this.chartData.bar.xAxis[0].data[xIndex];
      this.isClick = true;
      let option = this.chartData.pie;
      option.loading = false;
      const { bean } = await this.$services.post({
        type: 'LOGSTATISTICS',
        url: 'getOperateLogDepartPie',
        params: {
          startDate: date + ' 00:00:00',
          endDate: date + ' 23:59:59',
          depCode: this.queryParams.depCode ? this.queryParams.depCode : ''
        }
      });


      let legend = [];
      let sData = [];
      if (typeof (bean) === 'object') {
        // eslint-disable-next-line guard-for-in
        for (let key in bean) {
          legend.push(key);
          sData.push({
            name: key,
            value: bean[key]
          });
        }
      }

      option.legend.data = legend;
      option.series[0].data = sData;
      option.loading = true;

    }
  },
  created() {
    this.getOperationAelectALL();
    // this.getOperateLogDepartHistogram();
  }
};
</script>
<style lang="scss" scoped>
.pagination-box {
  text-align: center;
}

.chart-box {
  width: 100%;
  margin-top: 30px;
  #logBarContainer,#logPieContainer{
    width: 99.8%;
    height: 100%;
  }
}
</style>
